export const useSingleProductGroup = (product?: { ProductGroups: string[] } | null) => {
  if (product?.ProductGroups.length === 1) {
    return product.ProductGroups[0]
  }
  return null
}
